<template>
  <div class="wrap-faqs pt-8 pb-10">
    <div class="faqs-container container-lg d-flex">
      <b-list-group class="faqs-list">
        <b-list-group-item
          class="cursor-pointer"
          :active="activeFaqsItem === 'account'"
          @click="activeFaqsItem = 'account'"
          >帐户与系统</b-list-group-item
        >
        <b-list-group-item
          class="cursor-pointer"
          :active="activeFaqsItem === 'tournament'"
          @click="activeFaqsItem = 'tournament'"
          >比赛与证书</b-list-group-item
        >
        <b-list-group-item
          class="cursor-pointer"
          :active="activeFaqsItem === 'ai'"
          @click="activeFaqsItem = 'ai'"
          >AI 测评</b-list-group-item
        >
      </b-list-group>
      <div class="faqs-accordion" role="tablist">
        <template v-for="(item, index) in faqsItems">
          <Collapse
            :key="activeFaqsItem + index"
            :title="item.title"
            :contents="item.contents"
          ></Collapse>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Collapse from '@/components/Home/Collapse.vue';
import faqsConfig from '@/assets/config/faqs';

export default {
  name: 'Faqs',
  components: {Collapse},
  data() {
    return {
      activeFaqsItem: 'account',
      faqsConfig,
    };
  },
  computed: {
    faqsItems() {
      return faqsConfig[this.activeFaqsItem];
    },
  },
};
</script>

<style lang="scss">
.wrap-faqs {
  .faqs-list {
    width: 255px;
    color: $gray-700;
    margin-right: 30px;
  }
  .faqs-accordion {
    flex: 1;
  }
}
</style>
